import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const SoundPreferencesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateSoundPreferences: builder.mutation<ApiResponse<null>, boolean>({
      query: (effectsEnabled: boolean) => ({
        url: '/users/sound-preferences',
        method: 'PATCH',
        body: { effectsEnabled },
      }),
      invalidatesTags: [RTKQueryTag.User],
    }),
  }),
});

export const { useUpdateSoundPreferencesMutation } = SoundPreferencesApiSlice;
